import React, { useState, useEffect } from "react";
import Rating from '@material-ui/lab/Rating';
import Modal from "react-bootstrap/Modal";
import { toast } from 'react-toastify';
import moment from "moment";

import {
  StarDivision,
  ButtonDivision,
  CloseIcon,
  LoadingIcon,
  Limit
} from "./styles";

import Loading from "~/components/layout/Loading";
import api from '~/services/api';
import close from '~/assets/images/close.png';
import "~/components/styles/Global.css";

export default function RatingModal({ 
  resetAvaliation,
  setResetAvaliation,
  valueRating, 
  valueComment, 
  isConsultant, 
  isEditable, 
  showModal, 
  setShowModal 
}) {

  const [access, setAcess] = useState("");
  const [value, setValue] = useState(valueRating);
  const [comment, setComment] = useState(valueComment);
  const [firstTime, setFirstTime] = useState(true);
  const [editable, setEditable] = useState(isEditable ? isEditable : false);
  const [loading, setLoading] = useState(true);
  const [loadingRating, setLoadingRating] = useState(false);
  const [lastEdit, setLastEdit] = useState({
    userId: "",
    rating: 0,
    justification: "",
    department: "",
    creationDate: ""
  });

  const url = `/rating/v1/ratings`;

  useEffect(() => {
    if((showModal && lastEdit.userId === "") && !isConsultant) {
      getRating();
    } else {
      setLoadingRating(false);
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal]);

  async function getRating() {
    const headerAuth = {
      'Content-Type': 'application/json',
      'Accept-Language': 'pt-BR',
      Authorization: process.env.REACT_APP_SIGNIN_AUTHORIZATION,
      client_id: process.env.REACT_APP_CLIENT_ID,
    };
    const parametersAuth = {
      method: 'POST',
      headers: headerAuth,
    };
    const bodyAuth = {
      grant_type: 'client_credentials',
    };
    await api.post("residential/store/v1/users/authentications", bodyAuth, parametersAuth)
    .then((res) => {
      const headerRating = {
        'Content-Type': 'application/json',
        access_token: res.data.access_token,
      };
      const parametersRating = {
        method: 'GET',
        headers: headerRating,
      };
      setAcess(res.data.access_token);
      api.get(url + `?user-id=${localStorage.getItem("userId")}&_limit=1000`, parametersRating)
      .then((res) => {
        const response = res.data;
        if(response.length > 0) {
          let arrayMap = [];
          response.map((element) => {
            if(element.department === "MAP") {
              arrayMap.push(element);
            }
          });
          setLastEdit(arrayMap[arrayMap.length - 1]);
          console.log(arrayMap[arrayMap.length - 1].rating);
          setValue(arrayMap[arrayMap.length - 1].rating);
          setComment(arrayMap[arrayMap.length - 1].justification);
          setFirstTime(false);
        }
        setLoadingRating(false);
        setLoading(false);
      })
      .catch((err) => {
        toast.error("Ocorreu algum erro, tente novamente!");
        setLoadingRating(false);
        setLoading(false);
      })
    })
    .catch((err) => {})
  }

  function sendRating() {
    const headerPost = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('access_token'),
    };
  
    const parametersPost = {
      method: 'GET',
      headers: headerPost,
    };

    const body = {
      userId: localStorage.getItem("userId"),
      rating: value,
      justification: comment,
      department: isConsultant ? "COMMERCIAL_CONSULTANT" : "MAP",
      commercialConsultant: {
        idSalesforce: isConsultant && localStorage.getItem("consultantId"),
        name: isConsultant && localStorage.getItem("consultantName")
      }
    }

    api.post(url, body, parametersPost)
    .then((res) => {
      if(isConsultant) {
        setResetAvaliation(!resetAvaliation)
      }
      setEditable(false);
      setLastEdit({
        userId: "",
        rating: 0,
        justification: "",
        department: "",
        creationDate: ""
      });
      setValue(0);
      setComment("");
      setLoadingRating(false);
      toast.success("Avaliação realizada com sucesso");
      setShowModal(false);
    })
    .catch((err) => {})
  }

  function hasChanges() {
    if(lastEdit.rating === value) {
      if(lastEdit.justification === comment) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  function handleAvaliation() {
    if(firstTime) {
      setLoadingRating(true);
      sendRating();
    } else if(editable) {
      setLoadingRating(true);
      if(hasChanges()) {
        sendRating();
      } else {
        setLoadingRating(false);
        toast.error("Faça alguma mudança para enviar sua avaliação");
      }
    } else {
      setEditable(true);
    }
  }

  return(
    <Modal
      show={showModal}
      onHide={() => {
        setShowModal(false);
      }}
      className="modal-cancel"
      centered
    >
      <Modal.Body style={{ padding: ".5rem", borderRadius: 15 }}>
        <CloseIcon>
          <img 
            src={close} 
            alt="Ícone de fechar" 
            onClick={() => { 
              if(!isConsultant) {
                setEditable(false);
                setLastEdit({
                  userId: "",
                  rating: 0,
                  justification: "",
                  department: "",
                  creationDate: ""
                });
                setValue(0);
                setComment("");
              }
              setLoadingRating(false);
              setShowModal(false); 
            }} 
          />
        </CloseIcon>
        {
          loading ? (
            <Loading /> 
          ) : (
            <StarDivision>
              <h3>{ isConsultant ? "Avalie seu consultor" : "Avalie o MAP"}</h3>
              <p>Queremos saber o que está achando!</p>
              {
                firstTime || isConsultant ? (
                  <h4>
                    { 
                      firstTime || isConsultant ? "Faça uma avaliação" : "Sua última avaliação"
                    }
                  </h4>
                ) : (
                  <h4>
                    <>
                      { 
                        firstTime || isConsultant ? "Faça uma avaliação" : "Sua última avaliação"
                      }
                    </>
                    <span>
                      {lastEdit.creationDate === "" ? null : 
                      moment(lastEdit.creationDate).format("DD/MM/YYYY")}
                    </span>
                  </h4>
                )
              }
              <Rating
                name="simple-controlled"
                value={value}
                onChange={(event, newValue) => {
                  if(value !== newValue && newValue !== null) {
                    setValue(newValue);
                  }
                }}
                size="large"
                readOnly={!firstTime && !editable && !isConsultant ? true : false}
              />
              <h4>
                { 
                  firstTime || isConsultant ? "Deixe seu comentário abaixo" : "Seu último comentário"
                }
              </h4>
              {
                comment.length === 250 && (
                  <Limit>
                    <span>Limite de caracteres alcançado</span>
                  </Limit>
                )
              }
              {
                firstTime || editable || isConsultant ? (
                  <textarea 
                    placeholder="Comentário..." 
                    onChange={(e) => setComment(e.target.value)}
                    value={comment}
                    maxlength="250"
                  />
                ) : (
                  <p>{lastEdit.justification}</p>
                )
              }
              <ButtonDivision>
                <button 
                  active={!firstTime || value > 0 ? true : false} 
                  onClick={() => { 
                    if(value !== 0) {
                      handleAvaliation() 
                    }
                  }}
                >
                  {
                    loadingRating ? (
                      <LoadingIcon className="fa fa-spinner fa-pulse fa-3x fa-fw" />
                    ) : (
                      <>
                        {
                          firstTime || editable ? "Enviar" : "Editar" 
                        }
                      </>
                    )
                  }
                </button>
              </ButtonDivision>
            </StarDivision>
          )
        }
      </Modal.Body>
    </Modal>
  );
}